// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1CGtn","inputWrap":"styles_inputWrap__1L4Nc","input":"styles_input__1y8e9"};